/*!

=========================================================
* Material Dashboard PRO React - v1.9.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
* Copyright 2020 Creative Tim (https://www.creative-tim.com)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React, {useEffect, useState} from "react";
import ReactDOM from "react-dom";
import {Provider, useDispatch, useSelector} from 'react-redux';
import { createBrowserHistory } from "history";
import { Router, Route, Switch, Redirect } from "react-router-dom";
import store from './store';
import AuthLayout from "layouts/Auth.js";
import AdminLayout from "layouts/Admin.js";

import "./assets/scss/material-dashboard-pro-react.scss?v=1.9.0";

const hist = createBrowserHistory();
const App = () => {
  const isAuthenticated = useSelector(state => state.app.isAuthenticated);
  const isSessionTimeout = useSelector(state => state.app.isSessionTimeout);
  if(!isAuthenticated || isSessionTimeout){
    return <Switch>
      <Route path="/" component={AuthLayout} />
      <Redirect from="/" to="/stockroom" />
    </Switch>
  }
  return <Switch>
    <Route path="/stockroom" component={AdminLayout} />
    <Route path="/categories" component={AdminLayout} />
    <Route path="/permissions" component={AdminLayout} />
    <Route path="/images"  component={AdminLayout}/>
    <Route path="/csv"  component={AdminLayout}/>
    <Route path="/sellers" component={AdminLayout} />
    <Route path="/s3-browser" component={AdminLayout} />
    <Route path="/hours" component={AdminLayout} />
    <Route path="/events" component={AdminLayout} />
    <Redirect from="/" to="/stockroom" />
  </Switch>
}
ReactDOM.render(
  <Provider store={store}>
    <Router history={hist}>
        <App />
    </Router>
  </Provider>
  ,
  document.getElementById("root")
);
